import type { BuildFullPageExportFilenameInput } from './types.js';

function sanitizeFilenamePart(value: string, fallback: string): string {
  const trimmed = value.trim() || fallback;
  return trimmed.replace(/[^\w.-]+/g, '-');
}

function formatLocalTimestamp(now: Date): string {
  const year = String(now.getFullYear());
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${year}${month}${day}-${hours}${minutes}${seconds}`;
}

/** `admin-{sanitizedBusinessPartner}-{sanitizedSlug}-{YYYYMMDD-HHmmss}` in local time. */
export function buildFullPageExportFilename(input: BuildFullPageExportFilenameInput): string {
  const tenant = sanitizeFilenamePart(input.tenantCode, 'business-partner');
  const slug = sanitizeFilenamePart(input.screenSlug, 'screen');
  const stamp = formatLocalTimestamp(input.now ?? new Date());
  return `admin-${tenant}-${slug}-${stamp}`;
}
